var nextUniqueId = 0;
export function getNextUniqueId() {
  return nextUniqueId++;
}